export default "__VITE_ASSET__e8a040af__"